import arrowUpRightSvg from '@/assets/icons/arrow_up_right.svg';

interface ArrowUpRightProps {
  className?: string;
}

export default function ArrowUpRight({ className = '' }: ArrowUpRightProps) {
  return (
    <img
      src={arrowUpRightSvg}
      alt="Arrow up right"
      className={className}
    />
  );
}
